import { render, staticRenderFns } from "./OfferingsTimeout.vue?vue&type=template&id=55cd2a26&scoped=true&"
import script from "./OfferingsTimeout.vue?vue&type=script&lang=js&"
export * from "./OfferingsTimeout.vue?vue&type=script&lang=js&"
import style0 from "./OfferingsTimeout.vue?vue&type=style&index=0&id=55cd2a26&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55cd2a26",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('55cd2a26')) {
      api.createRecord('55cd2a26', component.options)
    } else {
      api.reload('55cd2a26', component.options)
    }
    module.hot.accept("./OfferingsTimeout.vue?vue&type=template&id=55cd2a26&scoped=true&", function () {
      api.rerender('55cd2a26', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/god/comp/OfferingsTimeout.vue"
export default component.exports